import React from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LogoImage } from '../../../atoms';
import Alert from '../../Alert';
import useResetPassword from './useResetPassword';
import ResetPasswordForm from './Form';
import { cn, useBreakpoints } from '@jobcost-monorepo/utils';

type Props = {
  token: string | null;
};

const ResetPassword: React.FC<Props> = ({ token }: Props) => {
  const { t } = useTranslation('auth');
  const { isSmall } = useBreakpoints();
  const { methods, loading, success, error, signInLink, handleResetPassword } =
    useResetPassword({
      token,
    });

  if (!token) {
    return (
      <div className="h-screen flex flex-col justify-center items-center py-12 bg-gray-50 sm:px-6 lg:px-8 ">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <LogoImage className="mx-auto h-12 w-auto" />
        </div>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white text-center py-8 px-4 shadow sm:rounded-lg sm:px-10">
            {t('resetPassword.invalidToken')}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex justify-center items-center w-screen h-screen overflow-hidden"
      style={{
        background:
          'linear-gradient(299.92deg, #514689 18.26%, #EF426F 117.31%)',
      }}
    >
      {error && (
        <Alert
          type="error"
          message={t('resetPassword.error')}
          //   duration={3000}
        />
      )}

      <div
        className={cn(
          'flex flex-col bg-white justify-center w-96 items-center rounded-[2rem] p-10',
          isSmall && 'mx-7',
        )}
      >
        <div className="flex justify-center items-center mb-8">
          <LogoImage className="mx-auto h-12 w-auto" />
        </div>
        {!success ? (
          <FormProvider {...methods}>
            <ResetPasswordForm
              onSubmit={handleResetPassword}
              loading={loading}
            />
          </FormProvider>
        ) : (
          <div className="space-y-6 items-center text-center">
            <p className="text-sm text-gray-700 text-center mb-4">
              {t('resetPassword.success')}
            </p>
            <a
              className="text-sm font-bold text-purple hover:opacity-80"
              href={signInLink}
            >
              {t('resetPassword.backToLogin')}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
export default ResetPassword;
